import React from 'react';
import SRF_Logo from "../../../SRF_Logo.svg";
const Footer = ({appTitle}) => {
    let title = appTitle

  return (
    <footer className="bg-secondary py-4 text-white text-center flex flex-col items-center shadow-inner">
                  <img className="h-8 w-min shadow-lg" src={SRF_Logo} alt="SRF LOGO" />
      <p>&copy; {new Date().getFullYear()} - {new Date().getFullYear()+1} { title ? title: "set the app name"}. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
